import React from "react";
import { Route } from "react-router-dom";
import { CustomRoutes, Resource } from "react-admin";
import { ModerationLobby, ModerationList } from "./moderation_entries";
import { ReportList, ReportIcon } from "./reports";
import { ModerationActivitiesList, ModerationActivitiesIcon } from "./moderation_activities";

export const routes = [
	<Resource name="reports" list={ReportList} icon={ReportIcon} />,
	<Resource name="moderation_activities" list={ModerationActivitiesList} icon={ModerationActivitiesIcon} />,
	<CustomRoutes>
		<Route path="/moderation_entries/lobby" element={<ModerationLobby />} />
		<Route path="/moderation_entries/moderation" element={<ModerationList />} />
	</CustomRoutes>,
];
